import { render, staticRenderFns } from "./KPIDetails.vue?vue&type=template&id=33bf81d8&scoped=true"
import script from "./KPIDetails.vue?vue&type=script&lang=js"
export * from "./KPIDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf81d8",
  null
  
)

export default component.exports